import React from 'react';
import './LoadingOverlay.css';

interface LoadingOverlayProps {
  isVisible: boolean;
  status?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isVisible, status }) => {
  if (!isVisible) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="swords-container">
          {/* Левый меч */}
          <svg className="sword sword-left" viewBox="0 0 100 300" width="60" height="180">
            <defs>
              <linearGradient id="blade-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#e0e0e0" />
                <stop offset="50%" stopColor="#ffffff" />
                <stop offset="100%" stopColor="#c0c0c0" />
              </linearGradient>
              <linearGradient id="hilt-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#8B4513" />
                <stop offset="100%" stopColor="#654321" />
              </linearGradient>
            </defs>
            
            {/* Лезвие */}
            <path d="M 45 10 L 50 0 L 55 10 L 55 200 L 50 210 L 45 200 Z" 
                  fill="url(#blade-gradient)" 
                  stroke="#999" 
                  strokeWidth="1"/>
            
            {/* Гарда */}
            <rect x="20" y="200" width="60" height="10" rx="2" fill="#666" />
            
            {/* Рукоять */}
            <rect x="45" y="210" width="10" height="60" rx="2" fill="url(#hilt-gradient)" />
            
            {/* Навершие */}
            <circle cx="50" cy="280" r="15" fill="#666" />
          </svg>

          {/* Правый меч */}
          <svg className="sword sword-right" viewBox="0 0 100 300" width="60" height="180">
            {/* Лезвие */}
            <path d="M 45 10 L 50 0 L 55 10 L 55 200 L 50 210 L 45 200 Z" 
                  fill="url(#blade-gradient)" 
                  stroke="#999" 
                  strokeWidth="1"/>
            
            {/* Гарда */}
            <rect x="20" y="200" width="60" height="10" rx="2" fill="#666" />
            
            {/* Рукоять */}
            <rect x="45" y="210" width="10" height="60" rx="2" fill="url(#hilt-gradient)" />
            
            {/* Навершие */}
            <circle cx="50" cy="280" r="15" fill="#666" />
          </svg>

          {/* Искры при ударе */}
          <div className="sparks">
            <div className="spark spark-1"></div>
            <div className="spark spark-2"></div>
            <div className="spark spark-3"></div>
            <div className="spark spark-4"></div>
          </div>
        </div>

        {status && (
          <div className="loading-status">
            {status}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
